import { SectionProps } from './types'
import SecureInput from '../../../ui/SecureInput/SecureInput'
import { User, Lock } from 'lucide-react'

export default function SqlAuthSection({ form, styles }: SectionProps) {
  const { watch, setValue } = form
  return (
    <>
      <div className={styles.field}>
        <SecureInput
          fieldType="name"
          label="Username"
          icon={<User size={16} />}
          value={watch('sql_auth.username') || ''}
          onChange={(value) => setValue('sql_auth.username', value)}
          placeholder="sa"
          autoComplete="new-username"
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="password"
          label="Password"
          icon={<Lock size={16} />}
          value={watch('sql_auth.password') || ''}
          onChange={(value) => setValue('sql_auth.password', value)}
          autoComplete="new-password"
          skipPasswordValidation={true}
          className={styles.input}
        />
      </div>
    </>
  )
}
